import { SahinDataTable } from 'common/components/DataTable/SahinDataTable';
import { EmptyState } from 'common/components/EmptyState';
import { FailedLoad } from 'common/components/FailedLoad/FailedLoad';
import { Loading } from 'common/components/Loading/Loading';
import { SahinButton } from 'common/components/SahinButton/SahinButton';
import { deleteAPI } from 'common/helper/apiHelpers';
import { useFetch } from 'common/hooks/useFetchSwr';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { Nullable } from 'common/model/Nullable';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { mutate } from 'swr';
import { CategoryForm } from '../Form/CategoryForm';
import { categoryListColumns } from './CategoryList.types';

export const COMPONENT_TABLE_PATH = AdminTablePaths.CATEGORY;

export const CategoryList = () => {
  const { branchId } = useParams<{ branchId: string }>();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(15); // Default 15

  const fetchUrl = `${COMPONENT_TABLE_PATH}?page=${currentPage}&per_page=${perPage}&branch=${branchId}`;

  const {
    data: categories,
    error,
    isLoading,
    totalData,
    totalPage,
  } = useFetch<Category[]>(fetchUrl);

  const [selectedItem, setSelected] =
    useState<Nullable<Partial<Category>>>(null);

  const onAdd = () => {
    setSelected({});
  };

  const onEdit = (selected: Category) => {
    setSelected(selected);
  };

  const onDelete = (selected: Category) => {
    deleteAPI(COMPONENT_TABLE_PATH, selected.id)
      .then(() => {
        const cacheKeys = [];
        for (let i = currentPage + 1; i <= (totalPage || 1); i++) {
          const cacheUrl = `${COMPONENT_TABLE_PATH}?page=${i}&per_page=${perPage}&branch=${branchId}`;
          cacheKeys.push(cacheUrl);
        }

        mutate(fetchUrl);
        cacheKeys.forEach((key) => mutate(key, undefined, false));
      })
      .catch((error) => console.error(error));
  };

  const onCloseModal = () => {
    setSelected(null);
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPerPage(newPageSize);
    setCurrentPage(1); // Sayfa boyutu değiştiğinde ilk sayfaya dön
  };

  if (error) return <FailedLoad />;
  if (isLoading) return <Loading />;

  return (
    <>
      <CategoryForm
        open={Boolean(selectedItem)}
        initialData={selectedItem}
        handleClose={onCloseModal}
        currentPage={currentPage}
        perPage={perPage}
      />
      <SahinDataTable
        data={categories}
        columns={categoryListColumns}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
        currentPage={currentPage}
        totalPages={totalPage || 1}
        totalData={totalData || 0}
        onPageChange={handlePageChange}
        pageSize={perPage}
        onPageSizeChange={handlePageSizeChange}
        customEmptyMessage={
          <EmptyState
            title="Henüz Kategori Yok"
            description="Menünüzü düzenlemek için kategoriler oluşturun"
            icon="📂"
            iconSize={55}
            tip="Kategoriler sayesinde ürünlerinizi düzenli bir şekilde gruplandırabilirsiniz. Örneğin: Ana Yemekler, İçecekler, Tatlılar gibi."
            tipTitle="💡 Kategori İpuçları"
            action={
              <SahinButton
                variant="contained"
                onClick={onAdd}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 500,
                  backgroundColor: '#2e2e2e',
                  textTransform: 'uppercase',
                }}
              >
                İlk Kategorinizi Oluşturun
              </SahinButton>
            }
          />
        }
      />
    </>
  );
};
